
module.exports = {

    methods: {
        
        getFilterOptionsFromField(){
            console.log(window.vueInstance.$store.state.currentWallField);
            console.log(window.vueInstance.$store.state.currentArticleSorting);
        }

    }
    
};


// WEBPACK FOOTER //
// ./client/mixins/filter.js